import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, saveSession } from "@/lib/api";
import Navbar from "@/components/karmivo/Navbar";

export default function WorkerLogin() {
  const nav = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/auth/login`, { phone, password, role: "worker" });
      saveSession("worker", data); toast.success("Welcome back"); nav("/worker/dashboard");
    } catch (e) { toast.error(e.response?.data?.detail || "Login failed"); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen bg-slate-900 text-slate-100"><Navbar/>
      <div className="max-w-md mx-auto px-6 py-16">
        <Card className="p-6 bg-slate-800 border-slate-700 text-slate-100">
          <h1 className="font-display text-2xl font-bold">Worker Login</h1>
          <p className="text-sm text-slate-400">Access assignments & payouts.</p>
          <div className="mt-5 space-y-3">
            <div><Label>Phone</Label><Input value={phone} onChange={e => setPhone(e.target.value)} className="bg-slate-900 border-slate-700" data-testid="wl-phone"/></div>
            <div><Label>Password</Label><Input type="password" value={password} onChange={e => setPassword(e.target.value)} className="bg-slate-900 border-slate-700" data-testid="wl-password"/></div>
            <Button className="w-full bg-orange-500 hover:bg-orange-600" onClick={submit} disabled={loading} data-testid="wl-submit">Login</Button>
            <p className="text-xs text-center">No account? <Link to="/worker/register" className="text-orange-400 font-semibold" data-testid="wl-register-link">Apply</Link></p>
          </div>
        </Card>
      </div>
    </div>
  );
}
